import { h } from 'preact'
import { useState, useEffect } from 'preact/hooks'

import imageDeFond from './fondCampagne.jpg'
import imagePhone from './iphoneCampagne.png'

export const Campagne = ({ type }) => {
   const data = {
      preco: {
         cookieValue: JSON.stringify({precommande_iphone_16: 1}),
         title: 'Nouveauté Apple',
         subtitle: 'iPhone 15 Pro',
         image: imagePhone,
         alt: 'iPhone 15 Pro',
         content: {
            tag: 'Nouveauté',
            title: 'iPhone Max Super Canard',
            attributes: [
               { icon: 'icon-internet', label: 'Internet à la maison' },
               { icon: 'icon-mon-reseau', label: 'Wifi Premium' },
               { icon: 'icon-orange-tv', label: "TV d'Orange" },
            ],
            tooltip: {
               title: 'DAS',
               content: {
                  head: '0,99 W/kg',
                  trunk: '0,98 W/kg',
                  members: '2,97 W/kg',
               },
            },
            price: {
               from: 'à partir de',
               amount: '18,99 €',
               srOnly: 'À partir de 18,99€',
            },
            button: {
               label: 'Précommander',
               link: 'https://www.orange.fr/',
               oevent: {
                  pdbZid: 'acc-digital_' + dataStoreHP.segRefZ + '_event_preco',
                  category: 'zone_evenementielle',
                  action: 'precommande_apple_16',
                  label: 'https://www.orange.fr/',
                  other: {
                     track_refZ: 'acc-digital_' + dataStoreHP.segRefZ + '_event_preco',
                  },
               },
            },
         },
      },
      commande: {
         cookieValue: JSON.stringify({commande_iphone_16: 1}),
         title: 'Nouveauté Apple',
         subtitle: 'iPhone 15 Pro',
         image: imagePhone,
         alt: 'iPhone 15 Pro',
         content: {
            tag: 'Nouveauté',
            title: 'iPhone Max Super Canard',
            attributes: [
               { icon: 'icon-internet', label: 'Internet à la maison' },
               { icon: 'icon-mon-reseau', label: 'Wifi Premium' },
               { icon: 'icon-orange-tv', label: "TV d'Orange" },
            ],
            tooltip: {
               title: 'DAS',
               content: {
                  head: '0,99 W/kg',
                  trunk: '0,98 W/kg',
                  members: '2,97 W/kg',
               },
            },
            price: {
               from: 'à partir de',
               amount: '18,99 €',
               srOnly: 'À partir de 18,99€',
            },
            button: {
               label: 'Commander',
               link: 'https://www.orange.fr/',
               oevent: {
                  pdbZid: 'acc-digital_' + dataStoreHP.segRefZ + '_event',
                  category: 'zone_evenementielle',
                  action: 'commande_apple_16',
                  label: 'https://www.orange.fr/',
                  other: {
                     track_refZ: 'acc-digital_' + dataStoreHP.segRefZ + '_event',
                  },
               },
            },
         },
      },
   }

   if (type === 'preco') {
      return <CampagnePomme {...data.preco} />
   }

   if (type === 'commande') {
      return <CampagnePomme {...data.commande} />
   }
}

const CampagnePomme = (props) => {
   // Animation
   const [imgFond, setimgFond] = useState(false)
   const [imgPhone, setimgPhone] = useState(false)

   useEffect(() => {
      // Détection du chargement de l'image de fond
      const img = new Image()
      img.src = imageDeFond
      img.onload = () => {
         setimgFond(true)
      }

      // Cookie de capping
      const nbJoursCookie = 20
      document.cookie = `o-HPevent=${props.cookieValue}; max-age=${60 * 60 * 24 * nbJoursCookie}; path=/`
   }, [])

   return (
      <div class="campagne" style={`background-image: url(${imageDeFond})`}>
         <div class="title">
            <h2 class="h1 mb-0">
               <span>{props.title}</span> {props.subtitle}
            </h2>
            <h3 class="mb-1">{props.subtitle}</h3>
         </div>
         <div class="content">
            <img src={props.image} alt={props.alt} class={`imageMobile ${imgPhone && imgFond ? 'animer' : ''}`} onLoad={() => setimgPhone(true)} />
            <TuileInfo props={props.content} />
         </div>
      </div>
   )
}

const TuileInfo = ({ props }) => {
   // Tooltip
   const [tooltip, setTooltip] = useState(false)
   const toggleTooltip = (e) => {
      e.preventDefault()
      setTooltip((prevTooltip) => !prevTooltip)
   }

   return (
      <div class="tuile-info lien-composite">
         <div class="ob1-tag">{props.tag}</div>

         <div class={`das text-dark ob1-tooltip ${tooltip ? 'active' : ''}`}>
            <span tabindex="0" class="ob1-tooltip-trigger picto-das" aria-hidden="true" onClick={toggleTooltip}>
               <span class="icon icon-info text-dark"></span>
               <strong class="text-dark">DAS</strong>
            </span>

            <div class="ob1-tooltip-content ob1-tooltip-bottom" id="tooltip-content-bottom">
               <span>
                  <span class="bold">DAS tête</span> : {props.tooltip.content.head}
                  <br />
                  <span class="bold">DAS tronc</span> : {props.tooltip.content.trunk}
                  <br />
                  <span class="bold">DAS membres</span> : {props.tooltip.content.members}
               </span>
            </div>
            <div class="ob1-tooltip-shadow"></div>
         </div>

         <div class="content">
            <div>
               <h4 class="title">
                  {props.title} <span>{props.subtitle}</span>
               </h4>
               <ul class="attributes-list">
                  {props.attributes.map((attribute, index) => (
                     <li key={index}>
                        <span class={`icon ${attribute.icon}`}></span> <span class="p-0 label">{attribute.label}</span>
                     </li>
                  ))}
               </ul>
            </div>
         </div>

         <div class="price ob1-price text-right" data-ob1-component="Price">
            <span class="sr-only">{props.price.srOnly}</span>
            <p aria-hidden="true">
               <span class="ob1-price-from">{props.price.from}</span>
               <span class="ob1-price-amount">{props.price.amount}</span>
            </p>
         </div>

         <a
            href={props.button.link}
            class="btn btn-primary"
            data-pdb-zid={props.button.oevent.pdbZid}
            data-pdb-sc="mpt"
            data-pdb-idc="xxxxx"
            data-pdb-vi="url_image"
            data-oevent-category={props.button.oevent.category}
            data-oevent-action={props.button.oevent.action}
            data-oevent-label={props.button.oevent.label}
            data-oevent-other={JSON.stringify(props.button.oevent.other)}
         >
            {props.button.label}
         </a>
      </div>
   )
}
